import { render, staticRenderFns } from "./x-switch.vue?vue&type=template&id=99e07e28&scoped=true&"
import script from "./x-switch.vue?vue&type=script&lang=js&"
export * from "./x-switch.vue?vue&type=script&lang=js&"
import style0 from "./x-switch.vue?vue&type=style&index=0&id=99e07e28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e07e28",
  null
  
)

export default component.exports